import { createAction, createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/oferta';

function ofertaCorrecto(state, action) {
  const { responseOferta, requestOferta } = action.payload;
  state.request = requestOferta;
  state.response = responseOferta;
  state.responseError = false;
}


function ofertaError(state, action) {
  const { responseValidar } = action.payload;
  state.response = responseValidar;
  state.request = [];
  state.responseError = true;
}


const ofertaCreate = createAction('oferta');


const ofertaReducer = createSlice({
  name: 'oferta',
  initialState: initState,
  reducers: {
    ofertaCorrecto,
    ofertaError,
  },
});

export const ofertaActions = {
  ...ofertaReducer.actions,
  ofertaCreate,
};

export default ofertaReducer.reducer;
